
import { storage } from '../lib/storage';
import { Bundle, Product } from '../types';

const STORAGE_KEY = 'lynqar_bundles';

export const bundleService = {
  getStoreBundles: (storeId: string): Bundle[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: Bundle[] = data ? JSON.parse(data) : [];
    return all.filter(b => b.storeId === storeId);
  },

  saveBundle: (bundle: Bundle) => {
    const data = localStorage.getItem(STORAGE_KEY);
    let all: Bundle[] = data ? JSON.parse(data) : [];
    const idx = all.findIndex(b => b.id === bundle.id);
    if (idx !== -1) all[idx] = bundle;
    else all.push(bundle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },

  deleteBundle: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: Bundle[] = JSON.parse(data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all.filter(b => b.id !== id)));
  },

  getProductBundles: (productId: string, storeId: string): Bundle[] => {
    return bundleService.getStoreBundles(storeId).filter(b => b.isActive && b.productIds.includes(productId));
  },

  getSmartSuggestion: (product: Product): { products: Product[]; discount: number; isSmart: boolean } | null => {
    const storeBundles = bundleService.getProductBundles(product.id, product.storeId);
    
    if (storeBundles.length > 0) {
      const allProducts = storage.getProducts();
      const bundle = storeBundles[0];
      const items = bundle.productIds
        .filter(id => id !== product.id)
        .map(id => allProducts.find(p => p.id === id))
        .filter(Boolean) as Product[];
      
      return { products: items, discount: bundle.discountPercentage, isSmart: false };
    }

    // Smart Fallback: Same category items
    const allProducts = storage.getProducts();
    const suggestions = allProducts
      .filter(p => p.storeId === product.storeId && p.categoryId === product.categoryId && p.id !== product.id && p.stock > 0)
      .slice(0, 2);

    if (suggestions.length > 0) {
      return { products: suggestions, discount: 5, isSmart: true };
    }

    return null;
  }
};
